module.exports = __webpack_public_path__ + "img/sushi-king-menu-03.d50a0bf2.png";